// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-dom/src/Css.js");
var React = require("react");
var $$Promise = require("reason-promise/src/js/promise.js");
var Id$LocalForage = require("@johnridesabike/bs-localforage/src/Id.bs.js");
var Record$LocalForage = require("@johnridesabike/bs-localforage/src/Record.bs.js");
var Color$BlossomPlayground = require("./Color.bs.js");
var Graph$BlossomPlayground = require("./Graph.bs.js");
var Icons$BlossomPlayground = require("./Icons.bs.js");
var Intro$BlossomPlayground = require("./Intro.bs.js");
var Dialog$BlossomPlayground = require("./Dialog.bs.js");
var ForceGraph$BlossomPlayground = require("./ForceGraph.bs.js");
var GraphTable$BlossomPlayground = require("./GraphTable.bs.js");
var SampleData$BlossomPlayground = require("./SampleData.bs.js");
var ChevronDown = require("react-feather/dist/icons/chevron-down");
var ChevronLeft = require("react-feather/dist/icons/chevron-left");

function App$Toggleable(Props) {
  var title = Props.title;
  var children = Props.children;
  var defaultOpt = Props.default;
  var $$default = defaultOpt !== undefined ? defaultOpt : /* Open */0;
  var match = React.useState(function () {
        return $$default;
      });
  var setToggle = match[1];
  var toggle = match[0];
  return React.createElement("div", {
              className: "how-to"
            }, React.createElement("h2", undefined, toggle ? React.createElement("button", {
                        className: "button-ghost",
                        onClick: (function (param) {
                            return setToggle(function (param) {
                                        return /* Open */0;
                                      });
                          })
                      }, title, " ", React.createElement(ChevronLeft.default, {
                            className: "icon"
                          })) : React.createElement("button", {
                        className: "button-ghost",
                        onClick: (function (param) {
                            return setToggle(function (param) {
                                        return /* Closed */1;
                                      });
                          })
                      }, title, " ", React.createElement(ChevronDown.default, {
                            className: "icon"
                          }))), toggle ? null : children);
}

function App$HowTo(Props) {
  return React.createElement(App$Toggleable, {
              title: "How to use the table",
              children: null
            }, React.createElement("p", undefined, "Each cell represents an edge (a link) between two vertices\n          (e.g., people). A number indicates the weight of the edge. A\n          blank cell indicates no edge exists."), React.createElement("p", undefined, "An edge highlighted in ", React.createElement("span", {
                      className: "color-green"
                    }, "green"), " has been chosen for matching. The vertices connected by that\n           edge are mated."), React.createElement("p", undefined, "The blossom algorithm will find the path (a set of mates)\n          that has the highest combined weight while including as\n          highest number of vertices."), React.createElement("p", undefined, "Enabling ", React.createElement("em", undefined, "maximum cardinality"), " will tell the algorithm to only accept paths with everyone\n          possible, even paths with dramatically lower weights."), React.createElement("p", undefined, "Edit an edge by clicking on its table cell. Edit a vertex by clicking\n         on its name."));
}

function App$Credits(Props) {
  return React.createElement(App$Toggleable, {
              title: "Credits",
              children: React.createElement("div", {
                    style: Css.style({
                          hd: Css.textAlign(/* center */98248149),
                          tl: /* [] */0
                        })
                  }, React.createElement("h3", undefined, "Creator & maintainer"), React.createElement("p", undefined, React.createElement("a", {
                            href: "https://johnridesa.bike/"
                          }, "John Jackson")), React.createElement("h3", undefined, "Software"), React.createElement("ul", {
                        style: Css.style({
                              hd: Css.columnCount(Css.count(2)),
                              tl: {
                                hd: Css.maxWidth(Css.px(320)),
                                tl: {
                                  hd: Css.margin(/* auto */-1065951377),
                                  tl: {
                                    hd: Css.padding(Css.px(0)),
                                    tl: {
                                      hd: Css.listStyleType(/* none */-922086728),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            })
                      }, React.createElement("li", undefined, React.createElement("a", {
                                href: "https://nodejs.org/en/"
                              }, React.createElement(Icons$BlossomPlayground.NodeJs.make, {
                                    style: Css.style({
                                          hd: Css.height(Css.em(1)),
                                          tl: /* [] */0
                                        })
                                  }), "Node.js")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://reactjs.org/"
                              }, React.createElement(Icons$BlossomPlayground.React.make, {
                                    style: Css.style({
                                          hd: Css.height(Css.em(1)),
                                          tl: /* [] */0
                                        })
                                  }), "React")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://reasonml.github.io/"
                              }, React.createElement(Icons$BlossomPlayground.Reason.make, {
                                    style: Css.style({
                                          hd: Css.height(Css.em(1)),
                                          tl: /* [] */0
                                        })
                                  }), "Reason")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://github.com/johnridesabike/re-blossom"
                              }, "🌺 re-blossom")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://d3js.org/"
                              }, React.createElement(Icons$BlossomPlayground.D3.make, {
                                    style: Css.style({
                                          hd: Css.height(Css.em(1)),
                                          tl: /* [] */0
                                        })
                                  }), "D3.js")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://bucklescript.github.io/"
                              }, "BuckleScript")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://github.com/MinimaHQ/re-formality"
                              }, "Formality")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://localforage.github.io/localForage/"
                              }, "LocalForage")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://github.com/reasonml-labs/bs-css"
                              }, "bs-css")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://github.com/aantron/promise"
                              }, "Reason Promise")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://github.com/glennsl/bs-json"
                              }, "bs-json")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://parceljs.org/"
                              }, "Parcel")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://github.com/"
                              }, "git + ", React.createElement(Icons$BlossomPlayground.GitHub.make, {
                                    style: Css.style({
                                          hd: Css.height(Css.em(1)),
                                          tl: /* [] */0
                                        }),
                                    fill: Color$BlossomPlayground.foreground
                                  }), "GitHub")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://reacttraining.com/reach-ui/"
                              }, "Reach UI")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://simpleicons.org/"
                              }, React.createElement(Icons$BlossomPlayground.SimpleIcons.make, {
                                    style: Css.style({
                                          hd: Css.height(Css.em(1)),
                                          tl: /* [] */0
                                        }),
                                    fill: Color$BlossomPlayground.foreground
                                  }), "Simple Icons")), React.createElement("li", undefined, React.createElement("a", {
                                href: "https://feathericons.com/"
                              }, "Feather icons")))),
              default: /* Closed */1
            });
}

var Id = Id$LocalForage.MakeEncodable({
      encode: Graph$BlossomPlayground.encode,
      decode: Graph$BlossomPlayground.decode
    });

var graph = Record$LocalForage.make({
      name: "blossom-playground",
      storeName: "blossom-playground"
    }, Id);

function App$Main(Props) {
  var graph$1 = Props.graph;
  var setShowIntro = Props.setShowIntro;
  var match = React.useReducer(Graph$BlossomPlayground.reducer, graph$1);
  var graph$2 = match[0];
  React.useEffect((function () {
          Record$LocalForage.set(graph, graph$2);
          
        }), [graph$2]);
  var vertices = Graph$BlossomPlayground.verticesToArray(graph$2);
  var match$1 = React.useState(function () {
        return /* NotMax */-432534671;
      });
  var cardinality = match$1[0];
  var mates = Graph$BlossomPlayground.Mates.useMates(cardinality, graph$2);
  return React.createElement("main", {
              className: "main",
              role: "main"
            }, React.createElement("h1", undefined, "Maximum Weighted Matching Finder"), React.createElement("p", {
                  style: Css.style({
                        hd: Css.textAlign(/* center */98248149),
                        tl: /* [] */0
                      })
                }, React.createElement("button", {
                      className: "show-intro",
                      onClick: (function (param) {
                          return setShowIntro(function (param) {
                                      return true;
                                    });
                        })
                    }, "Show introduction")), React.createElement("div", {
                  className: "layout"
                }, React.createElement(GraphTable$BlossomPlayground.make, {
                      vertices: vertices,
                      graph: graph$2,
                      dispatch: match[1],
                      cardinality: cardinality,
                      setCardinality: match$1[1],
                      mates: mates
                    }), React.createElement(ForceGraph$BlossomPlayground.make, {
                      graph: graph$2,
                      mates: mates,
                      width: 400,
                      height: 400
                    })), React.createElement(App$HowTo, {}), React.createElement(App$Credits, {}), React.createElement("footer", {
                  className: "footer font-small"
                }, React.createElement("p", undefined, "Copyright \xa9 2020 ", React.createElement("a", {
                          href: "https://johnridesa.bike/"
                        }, "John Jackson")), React.createElement("p", undefined, React.createElement("a", {
                          href: "https://github.com/johnridesabike/mwmatching-finder"
                        }, "Browse the source")), React.createElement("p", undefined, "Powered by: ", React.createElement("a", {
                          href: "https://reactjs.org/"
                        }, React.createElement(Icons$BlossomPlayground.React.make, {
                              style: Css.style({
                                    hd: Css.height(Css.em(1)),
                                    tl: /* [] */0
                                  })
                            }), "React"), " ", React.createElement("a", {
                          href: "https://reasonml.github.io/"
                        }, React.createElement(Icons$BlossomPlayground.Reason.make, {
                              style: Css.style({
                                    hd: Css.height(Css.em(1)),
                                    tl: /* [] */0
                                  })
                            }), "Reason"), "\xa0 ", React.createElement("a", {
                          href: "https://github.com/johnridesabike/re-blossom"
                        }, "🌺 re-blossom"))));
}

function App(Props) {
  var match = React.useState(function () {
        return /* Loading */0;
      });
  var setLoaded = match[1];
  var loaded = match[0];
  var match$1 = React.useState(function () {
        return false;
      });
  var setShowIntro = match$1[1];
  React.useEffect((function () {
          $$Promise.tapError($$Promise.tapOk($$Promise.Js.toResult($$Promise.Js.fromBsPromise(Record$LocalForage.get(graph))), (function (graph) {
                      return setLoaded(function (param) {
                                  return /* Loaded */{
                                          _0: graph
                                        };
                                });
                    })), (function (param) {
                  setLoaded(function (param) {
                        return /* Loaded */{
                                _0: SampleData$BlossomPlayground.a
                              };
                      });
                  return setShowIntro(function (param) {
                              return true;
                            });
                }));
          
        }), []);
  if (loaded) {
    return React.createElement(React.Fragment, {
                children: null
              }, React.createElement(App$Main, {
                    graph: loaded._0,
                    setShowIntro: setShowIntro
                  }), match$1[0] ? React.createElement(Dialog$BlossomPlayground.make, {
                      onDismiss: (function (param) {
                          return setShowIntro(function (param) {
                                      return false;
                                    });
                        }),
                      ariaLabel: "Introduction to maximum weighted matching ",
                      children: React.createElement(Intro$BlossomPlayground.make, {
                            close: (function () {
                                return setShowIntro(function (param) {
                                            return false;
                                          });
                              })
                          })
                    }) : null);
  } else {
    return null;
  }
}

var make = App;

exports.make = make;
/* Id Not a pure module */
